import { useState } from "react";
import { PathPickerModal } from "./path-picker-modal.js";

// 3.B.2.1: Restore-target-valitsin. Käyttäjä voi:
//   - Hyväksyä ehdotetun "~/Kratti-restored/<timestamp>/" -polun (default)
//   - Muokata polkua suoraan input-kenttään
//   - Selata Finderissa (PathPickerModal, vaatii machineId)
//
// Restore EI saa kirjoittaa olemassa olevaa polkua päälle. Daemon-puolen
// snapshot-restore-handler tarkistaa pathExists ennen kopian kutsumista.

export type RestoreTargetPickerProps = {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  /** Daemon-puolen machineId — mahdollistaa Finder-pickerin. */
  machineId?: string;
};

/** Generoi suositeltu restore-target-polku timestampilla. */
export function suggestRestoreTarget(now: Date = new Date()): string {
  const stamp = now.toISOString().replace(/\.\d{3}Z$/, "Z").replace(/:/g, "-");
  return `$HOME/Kratti-restored/${stamp}`;
}

export function RestoreTargetPicker({
  value,
  onChange,
  disabled,
  machineId,
}: RestoreTargetPickerProps) {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div className="space-y-1">
      <label className="block text-xs font-medium uppercase tracking-wide text-slate-400">
        Kohdepolku
      </label>
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="flex-1 rounded bg-slate-800 px-3 py-2 text-sm text-slate-100 placeholder-slate-500 disabled:opacity-50"
          placeholder={suggestRestoreTarget()}
        />
        <button
          type="button"
          onClick={() => setPickerOpen(true)}
          disabled={disabled}
          className="rounded bg-slate-700 px-3 py-2 text-sm font-medium text-slate-100 hover:bg-slate-600 disabled:opacity-50"
          title="Selaa polku"
        >
          📁
        </button>
      </div>
      <p className="text-xs text-slate-500">
        Daemon palauttaa tiedostot tähän polkuun. Polku ei saa olla olemassa
        — Kratti luo sen.
      </p>
      {pickerOpen && (
        <PathPickerModal
          title="Valitse restore-kohdepolku"
          initialPath={value}
          {...(machineId ? { machineId } : {})}
          onSelect={(p) => onChange(p)}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
}
